import React from 'react';
import { DatePicker } from '../../../ClickableField/ClickableField';
import moment from 'moment';

class RemindDateControl extends React.PureComponent {
  render() {
    const { fsReminderDate, onChange, className, InputProps, slotProps, ...rest } = this.props;

    return (
      <DatePicker
        className={`${className ? className : ''}`}
        name="fsReminderDate"
        format="DD-MMM-YYYY"
        value={
          /*moment.parseZone is equivalent to parsing the string and using moment utcoffset and to handle the date for -utc as well as it works for +utc*/
          !fsReminderDate ? null : moment.parseZone(fsReminderDate)
        }
        onChange={date => onChange(date)}
        slotProps={{
          field: { clearable: true },
          ...slotProps
        }}
        {...rest}
      />
    );
  }
}

export default RemindDateControl;
